module.exports = __webpack_public_path__ + "static/media/slider-img.4d18a214.png";